<template>
<section class="date-range">
  <el-select
    v-model="halfYears"
    multiple
    size="small"
    style="width:170px;"
    @change="onSelectChanged"
  >
    <el-option
      v-for="option in options"
      :key="option.value"
      :value="option.value"
      :label="option.label"
    />
  </el-select>

  <compare-time-year @on-years-changed="onYearsChanged" />
</section>
</template>

<script>
export default {
  name: 'CompareTimeHalfYear',
  props: {
    query: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      halfYears: ['上半年']
    }
  },
  computed: {
    options: () => [{
      value: '上半年',
      label: '上半年'
    }, {
      value: '下半年',
      label: '下半年'
    }]
  },
  methods: {
    onSelectChanged () {
      this.setQuery()
    },
    onYearsChanged (years) {
      this.years = years
      this.setQuery()
    },
    setQuery () {
      let {years, halfYears, query} = this

      if (!Array.isArray(years) || years.length === 0 || !Array.isArray(halfYears) || halfYears.length === 0) {
        query.queryTimes = []
        this.$emit('select-changed', false)
        return
      }

      query.queryTimes = years.reduce((list, year) => halfYears.reduce((list, halfYear) => {
        list.push(`${year}${halfYear}`)
        return list
      }, list), [])

      this.$emit('select-changed', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.date-range {
  display: inline-block;

  .el-select {
    /deep/ {
      .el-select__tags {
        height: 32px;
        align-items: center;
        flex-wrap: nowrap;
        overflow: hidden;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/CompareTime/HalfYear.vue